export default class ElementId {
	private static counters:{[key: string]: number} = {};

	public static new = (slug:string = "", nosuffix = false) : string => {
		if(!ElementId.counters[slug]) ElementId.counters[slug] = 0;
		let id = ElementId.counters[slug]++;
		return nosuffix ? String(id) : slug + "_" + id;
	};
}